import { datadogRum } from '@datadog/browser-rum'
import { v4 as uuidv4 } from 'uuid'
import { fetch } from '@dhl/fetch'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const buildBody = (mopinionToken: string, surveyId: number, values: Record<string, any>[]) => {
  const id = uuidv4()
  const domain = 'dhl.mopinion.com'

  return {
    survey: false,
    followup: false,
    token: mopinionToken,
    domain,
    surveyid: surveyId,
    data: [
      {
        label: 'Survey ID',
        value: id,
        type: 'id',
      },
      {
        label: 'url',
        value: window.location?.href || 'unknown',
        type: 'url',
      },
      {
        label: 'Viewport Height',
        value: window.screen?.height || 0,
        type: 'viewport',
      },
      {
        label: 'Viewport Width',
        value: window.screen?.width || 0,
        type: 'viewport',
      },
      {
        label: 'Viewport',
        value: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
        type: 'viewport',
      },
      {
        label: 'User Agent',
        type: 'agent',
        value: window.navigator?.userAgent || 'unknown',
      },
      ...values,
    ],
  }
}

export const useMopinion = (mopinionToken: string | undefined) => ({
  enabled: Boolean(mopinionToken),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reportFeedback: async (surveyId: number, values: Record<string, any>[]): Promise<void> => {
    if (!mopinionToken) {
      return
    }

    try {
      await fetch({
        method: 'POST',
        url: 'https://survey.dhl.mopinion.com/api/1/data',
        body: buildBody(mopinionToken, surveyId, values),
        headers: {
          token: mopinionToken,
          'Content-Type': 'application/json',
        },
      })
    } catch (e) {
      datadogRum.addError(e, { values })
      throw e
    }
  },
})
